<template>
  <div>
    <v-container fluid class="pa-0">
      <v-row> </v-row>
      <v-row class="pa-5">
        <v-col cols="12">
          <v-card class="d-flex">
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-tabs class="d-flex">
            <v-tab
              @click="
                reporte = 0;
                clear();
              "
              >Ventas</v-tab
            >
            <v-tab
              @click="
                reporte = 1;
                clear();
              "
              >Clientes</v-tab
            >
            <v-tab
              @click="
                reporte = 2;
                clear();
              "
              >Mecánicos</v-tab
            >
            <v-tab
              @click="
                reporte = 3;
                clear();
              "
              >Ordenes</v-tab
            >
          </v-tabs>
          <v-card>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-if="reporte != 3 && reporte != 1"
              >
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  v-if="reporte != 1"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="rangeText"
                      range
                      label="Rango de fechas"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      solo
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" range no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      CANCELAR
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu.save(date), consultar()"
                    >
                      ACEPTAR
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3" v-if="reporte == 0">
                <v-select
                  v-model="status"
                  :items="arrStatus"
                  item-text="name"
                  item-value="id"
                  label="Estatus"
                  persistent-hint
                  single-line
                  solo
                ></v-select>
              </v-col>
              <v-col cols="3" v-if="reporte == 3">
                <v-text-field
                  v-model="orden"
                  range
                  prefix="AAA-"
                  label="Orden"
                  type="number"
                  solo
                  @keypress.enter="consultar"
                ></v-text-field>
              </v-col>
              <v-col
                cols="3"
                v-if="reporte == 3 || reporte == 1 || reporte == 0"
              >
                <v-btn
                  @click="consultar"
                  :disabled="handleDisabled"
                  color="success"
                  class="mt-3"
                  >Consultar reporte</v-btn
                >
              </v-col>
              <v-col>
                <download-excel
                  class="btn btn-default float-right mr-3"
                  :data="items"
                  :fields="headersJson"
                  :before-generate="checkItem"
                  worksheet="My Worksheet"
                  name="reporte.xls"
                  v-if="reporte != 3"
                >
                  <button color="teal" elevation="2" outlined
                    ><v-icon
                      :class="
                        items?.length < 1
                          ? 'icon-download-disabled'
                          : 'icon-download'
                      "
                      >mdi-tray-arrow-down</v-icon
                    >
                  </button>
                </download-excel>
              </v-col>
            </v-row>
            <v-data-table
              :item-key="items._id"
              :headers="headers"
              :items="items"
              :search="search"
              :options.sync="options"
              :server-items-length="totales"
              multi-sort
              :loading="loading"
              loading-text="Generando reporte, un momento..."
              v-if="reporte != 3"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>Reportes</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Buscar en el reporte"
                    single-line
                    @keypress.enter="consultar()"
                    hide-details
                    class="mr-4"
                  ></v-text-field>
                </v-toolbar>
              </template>
              <template v-if="reporte == 3" #item.cliente="{ item }"
                >{{ item.order_id.client.name }}
                {{ item.order_id.client.first_lastname }}
                {{ item.order_id.client.second_lastname }}</template
              >
              <template v-if="reporte == 3" #item.fecha_venta="{ item }"
                >{{ item.createdAt | moment("YYYY-MM-DD hh:mm A") }}
              </template>
              <template
                v-if="reporte == 3"
                v-slot:expanded-item="{ headers, item }"
              >
                <td :colspan="headers?.length">
                  <v-row>
                    <v-col>
                      <h5>DETALLE VENTA</h5>
                      <div
                        v-for="(detail, index) in item.sale_detail"
                        :key="index"
                      >
                        <span>
                          {{
                            detail.product
                              ? "Producto: " + detail.product.name
                              : "Servicio: " + detail.service.name
                          }}</span
                        >
                        <span> Cantidad: {{ detail.quantity }} </span>
                        <span> Precio: {{ detail.price }} </span>
                      </div>
                    </v-col>
                    <v-col>
                      <imprimir-venta :venta="items[0]" />
                    </v-col>
                  </v-row>
                </td>
              </template>
            </v-data-table>
            <v-row v-else>
              <TicketOrden v-if="ordenCompleta" :ticket="ordenCompleta" />
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import moment from "moment";
import ReportsService from "../services/reports";
import TicketOrden from "./pages/TicketOrden.vue";
import JsonExcel from "vue-json-excel";
import { FormatMoney } from "format-money-js";
export default {
  name: "Reportes",
  data() {
    return {
      fm: new FormatMoney({
        decimals: 2,
      }),
      search: null,
      loading: false,
      reporte: 0,
      headers: [{}],
      options: {},
      totales: null,
      headersJson: null,
      items: [],
      inicio: null,
      fin: null,
      date: [],
      menu: false,
      cliente: null,
      orden: null,
      ordenCompleta: null,
      rangeText: null,
      arrStatus: [
        { id: 0, name: "CANCELADAS" },
        { id: 1, name: "ACTIVAS" },
        { id: 2, name: "TODAS" },
      ],
      status: 2,
    };
  },
  mounted() {
    this.defaultReportZero();
  },
  components: {
    TicketOrden,
    downloadExcel: JsonExcel,
  },
  computed: {
    // dateRangeText() {
    //   return this.date.join(" ~ ");
    // },
    handleDisabled() {
      if (this.reporte === 1) return false;
      if (this.reporte === 0) return false;
      if (this.reporte === 3 && this.orden) return false;
      return true;
    },
  },
  methods: {
    checkItem() {
      if (this.items?.length < 1) return;
    },
    defaultReportZero() {
      if (this.reporte === 0 || this.reporte === 2) {
        (this.date[0] = String(moment().startOf("month").format("YYYY-MM-DD"))),
          (this.date[1] = String(
            moment().utc().endOf("month").format("YYYY-MM-DD")
          ));
        this.rangeText = this.date.join(" ~ ");
      }
    },
    clear() {
      this.headers = [];
      this.items = [];
      this.headersJson = null;
    },
    consultar() {
      this.loading = true;
      this.headers = [];
      this.items = [];
      if (this.reporte == 0) this.reporteVentas(true);
      else if (this.reporte == 1) this.reporteClientes(true);
      else if (this.reporte == 2) this.reporteMecanicos(true);
      else this.reporteO();
    },
    async reporteVentas(resetPage = false) {
      console.log(this.status);
      if (resetPage) this.options.page = 1;
      let parametros;
      if (this.status == 2) {
        parametros = {
          fechaInicio: this.date[0],
          fechaFin: this.date[1] || this.date[0],
        };
      } else {
        parametros = {
          fechaInicio: this.date[0],
          fechaFin: this.date[1] || this.date[0],
          status: this.status,
        };
      }
      this.headers = [
        { text: "Folio de Venta", value: "serial_sale" },
        { text: "Cliente", value: "client" },
        { text: "Automovil", value: "vehiculo" },
        { text: "Fecha de Venta", value: "fecha_venta" },
        { text: "Estatus", value: "estatus_venta" },
        { text: "Total", value: "total" },
      ];
      this.crearJson();
      try {
        this.loading = true;
        // const res = await ReportsService.ventasPorFiltro(parametros);
        const res = await ReportsService.getSales({
          busqueda: this.search,
          ...this.options,
          ...parametros,
        });
        this.loading = false;
        res.data.sales = res.data.sales.map((m) => {
          m.vehiculo = `${m.vehiculo || "No disponible"}`;
          m.estatus_venta = m.status == 1 ? "COMPLETADA" : "CANCELADA";
          m.fecha_venta = moment(m.createdAt).format("YYYY-MM-DD hh:mm A");
          m.total = `$${this.fm.from(m?.total)}`//"$" + m?.total.toFixed(2);
          return m;
        });
        this.totales = res.data.totalPages;
        this.items = res.data.sales;
      } catch (error) {
        this.loading = false;
        return error;
      }
    },
    async reporteClientes(resetPage = false) {
      try {
        this.loading = true;
        if (resetPage) this.options.page = 1;
        this.headers = [
          { text: "Codigo de cliente", value: "code" },
          // { text: "RFC", value: "rfc" },
          { text: "Cliente", value: "cliente" },
          { text: "Ordenes Total", value: "orders" },
          { text: "Ordenes Activas", value: "active_orders" },
          { text: "Fecha ultima visita", value: "last_visit" },
          { text: "Total Vendido", value: "total" },
        ];
        this.crearJson();
        const res = await ReportsService.clientes({
          busqueda: this.search,
          ...this.options,
        });
        this.loading = false;
        res.data.clients = res.data.clients.map((m) => {
          m.last_visit = moment(m.last_visit).format("YYYY-MM-DD hh:mm A");
          m.total =  `$${this.fm.from(m.total_sale)}` //"$" + m.total_sale.toFixed(2);
          return m;
        });
        this.totales = res.data.totalPages;
        this.items = res.data.clients;
      } catch (err) {
        this.loading = false;
        return err;
      }
    },
    async reporteMecanicos(resetPage = false) {
      try {
        if (resetPage) this.options.page = 1;
        this.loading = true;
        const parametros = {
          fechaInicio: this.date[0],
          fechaFin: this.date[1] || this.date[0],
        };
        this.headers = [
          { text: "Mecanico", value: "mecanico" },
          { text: "Nº ordenes canceladas", value: "ordenes_canceladas" },
          { text: "Nº ordenes pendientes", value: "ordenes_pendientes" },
          { text: "Nº ordenes activas", value: "ordenes_activas" },
          { text: "Nº ordenes  finalizadas", value: "ordenes_finalizadas" },
          { text: "Nº ordenes totales", value: "ordenesTotales" },
        ];
        this.crearJson();
        const res = await ReportsService.mecanicos({
          busqueda: this.search,
          ...parametros,
          ...this.options,
        });
        this.totales = res.data.totalPages;
        this.items = res.data.data;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        return error;
      }
    },
    async reporteO() {
      try {
        this.loading = true;
        const orden = "AAA-" + String(this.orden)?.padStart(7, 0);
        this.headers = [
          { text: "Fecha", value: "fecha_venta" },
          { text: "Cliente", value: "cliente" },
          { text: "Total de Venta", value: "total" },
        ];
        this.crearJson();
        this.ordenCompleta = null;
        const res = await ReportsService.ventasPorOrden(orden);
        this.loading = false;
        this.ordenCompleta = res?.data;
      } catch (error) {
        this.loading = false;
        return error;
      }
    },
    crearJson() {
      this.headersJson = this.headers.reduce((target, key) => {
        target[key.text] = key.value;
        return target;
      }, {});
    },
  },
  watch: {
    options: {
      handler() {
        if (this.reporte == 0) {
          this.reporteVentas();
        } else if (this.reporte == 1) {
          this.reporteClientes();
        } else if (this.reporte == 2) {
          this.reporteMecanicos();
        }
      },
      deep: true,
    },
    reporte() {
      this.search = "";
      // Valores por defecto al cambiar de reporte
      this.loading = false;
      this.items = [];
      this.date = [];
      this.menu = false;
      if (this.reporte !== 0 && this.reporte !== 2) {
        this.rangeText = null;
      } else {
        this.defaultReportZero();
      }
      if (this.reporte == 0 || this.reporte == 1 || this.reporte == 2)
        this.consultar();
    },
    status() {
      if (this.date.length > 1) {
        this.consultar();
      } else {
        this.defaultReportZero();
        this.consultar();
      }
    },
    date() {
      if (this.date.length > 1) {
        this.rangeText = this.date.join(" ~ ");
      }
    },
  },
};
</script>
<style scoped>
.v-tab {
  background-color: #ffffff !important;
  width: 130px !important;
  border-radius: 5px 5px 0 0 !important;
  margin-right: 2px !important;
  box-shadow: -4px -5px 10px -8px rgb(148 148 148) !important;
  border-color: black !important;
  position: relative !important;
  top: 5px !important;
}
.v-slide-group__wrapper {
  position: relative !important;
  top: 2px !important;
  z-index: 4 !important;
}
.v-tab--active {
  color: inherit !important;
  font-weight: 900 !important;
}
.icon-download {
  cursor: pointer;
}

.icon-download-disabled {
  cursor: no-drop;
  opacity: 0.5;
}
</style>
